
import { UPDATE_LOAD_MODAL_EDITION_CREATE } from '../constants/loading';

export const updateLoadModalEdition = (value=false) => {
    return {
        type: UPDATE_LOAD_MODAL_EDITION_CREATE,
        payload: value,
    }
}